import React from "react";
import { Icon } from "@bookingcom/bui-react";
import { CheckmarkSelectedFillIcon, DollarCircleFillIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import styles from "./styles.module.css";
export const IconWithInclusionType = ({ icon, inclusionType, ariaLabel }) => {
    return (React.createElement("div", { className: styles.root, "aria-label": ariaLabel },
        React.createElement(Icon, { size: "large", svg: icon }),
        inclusionType === "INCLUDED" ? (React.createElement(Icon, { className: styles.inclusionTypeIcon, size: "smallest", svg: CheckmarkSelectedFillIcon, color: "constructive" })) : (React.createElement(Icon, { className: styles.inclusionTypeIcon, size: "smallest", svg: DollarCircleFillIcon }))));
};
